import axiosInstance from '@/plugins/api/axiosInstance';

export default function miscellaneous() {
    return {
        services
    };

    function services() {
        return {
            index
        };

        function index() {
            return axiosInstance.get(`miscellaneous/listservices`);
        }
    }
}
